"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TwentyFourHourReception;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function TwentyFourHourReception(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "_24-hour-reception",
    "data-name": "24-hour-reception"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.073,24.2a2.5,2.5,0,0,0-3.331,1.185l-4.621,9.722A39.324,39.324,0,1,0,59.534,87.148a2.5,2.5,0,1,0-1.623-4.728A34.281,34.281,0,1,1,78.343,36.643l-10.72-5.118a2.5,2.5,0,0,0-2.154,4.512l16.278,7.772a2.5,2.5,0,0,0,3.335-1.183l7.176-15.1A2.5,2.5,0,0,0,91.073,24.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.829,50.669a13.531,13.531,0,0,0-9.4,12.236,2.5,2.5,0,0,0,2.5,2.549H42.167a2.5,2.5,0,0,0,0-5H30.01a8.336,8.336,0,0,1,5.383-5.035c4.616-1.52,7.628-3.773,8.953-6.7a7.645,7.645,0,0,0,.351-5.535c-.69-2.934-3.882-7.866-11.448-6.733a10.811,10.811,0,0,0-8.586,7.2,2.488,2.488,0,0,0,1.645,3.1,2.514,2.514,0,0,0,3.132-1.619A5.8,5.8,0,0,1,33.991,41.4c4.614-.7,5.651,2.134,5.851,2.982a2.5,2.5,0,0,0,.148.478,2.756,2.756,0,0,1-.2,1.8C39.087,48.21,36.97,49.636,33.829,50.669Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.321,53.875H62.6V38.836a2.486,2.486,0,0,0-1.65-2.311,2.546,2.546,0,0,0-2.788.73c-.032.036-.063.074-.093.112L44.553,54.846a2.5,2.5,0,0,0,1.977,4.029H57.6v4.079a2.5,2.5,0,1,0,5,0V58.875h3.722a2.5,2.5,0,0,0,0-5Zm-8.722,0H51.624L57.6,46.148Z"
  })))));
}